import { Map as ImmutableMap } from 'immutable';
import useCollabGenerateTriggers from 'automation-ui-canvas/copilot-collaboration/hooks/useCollabGenerateTriggers';
const useGetCollabGenTriggersFlowData = ({
  flow
}) => {
  const {
    sendActionFromAppToCopilot,
    isCopilotReady
  } = useCollabGenerateTriggers({
    sessionId: `workflows-collaborate-ui-${flow.getFlowId()}`
  });
  return {
    actionCardPropsById: ImmutableMap([]),
    isCopilotReady,
    sendActionFromAppToCopilot
  };
};
export default useGetCollabGenTriggersFlowData;